// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KYEZ8ZTihyI2zurWfM3q{color:var(--light-blue-60)}.JPUulnxwMx25j6ijkQ7o{margin-right:8px}`, "",{"version":3,"sources":["webpack://./src/shared/ui/Table/ui/SelectedContent/HeaderCenterContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,0BAAA,CAEF,sBACE,gBAAA","sourcesContent":[".selectAllButton {\n  color: var(--light-blue-60);\n}\n.text {\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectAllButton": `KYEZ8ZTihyI2zurWfM3q`,
	"text": `JPUulnxwMx25j6ijkQ7o`
};
export default ___CSS_LOADER_EXPORT___;
